/**
 * Do not edit directly
 * Generated on Thu, 26 May 2022 21:11:18 GMT
 * Made by Pagar.me BaaS
 */

const COLORS = {
  BASE_TURQUOISE_20: "#9ce4ed",
  BASE_TURQUOISE_50: "#4ecdde",
  BASE_TURQUOISE_100: "#1695a6",
  BASE_TURQUOISE_200: "#0f6773",
  BASE_TURQUOISE_800: "#0c5059",
  BASE_GREEN_20: "#bcebd7",
  BASE_GREEN_50: "#4aba89",
  BASE_GREEN_100: "#1c8c5c",
  BASE_GREEN_200: "#156644",
  BASE_GREEN_800: "#104d33",
  BASE_LIME_20: "#ebf7df",
  BASE_LIME_50: "#90c458",
  BASE_LIME_100: "#63992e",
  BASE_LIME_200: "#4b7322",
  BASE_LIME_800: "#3a591a",
  BASE_CYAN_20: "#d2e7ff",
  BASE_CYAN_50: "#509cf2",
  BASE_CYAN_100: "#2b7dd9",
  BASE_CYAN_200: "#2467b3",
  BASE_CYAN_800: "#1e5594",
  BASE_BLUE_20: "#e2efff",
  BASE_BLUE_50: "#5691d6",
  BASE_BLUE_100: "#4079bb",
  BASE_BLUE_200: "#235894",
  BASE_BLUE_800: "#003c73",
  BASE_PURPLE_20: "#dfd2f7",
  BASE_PURPLE_50: "#916cd9",
  BASE_PURPLE_100: "#7155ab",
  BASE_PURPLE_200: "#553f80",
  BASE_PURPLE_800: "#443266",
  BASE_PINK_20: "#fbe5ec",
  BASE_PINK_50: "#f55d8b",
  BASE_PINK_100: "#df285f",
  BASE_PINK_200: "#a71a44",
  BASE_PINK_800: "#732640",
  BASE_RED_20: "#f8d4cd",
  BASE_RED_50: "#e6735c",
  BASE_RED_100: "#f85130",
  BASE_RED_200: "#bf4830",
  BASE_RED_800: "#993926",
  BASE_ORANGE_20: "#fae2d2",
  BASE_ORANGE_50: "#f4893f",
  BASE_ORANGE_100: "#ec6e16",
  BASE_ORANGE_200: "#c25408",
  BASE_ORANGE_800: "#732b1c",
  BASE_YELLOW_20: "#fff6d9",
  BASE_YELLOW_50: "#f8cc43",
  BASE_YELLOW_100: "#f3b700",
  BASE_YELLOW_200: "#d9a600",
  BASE_YELLOW_800: "#b38900",
  BASE_GREY_0: "#ffffff",
  BASE_GREY_20: "#f2f2f3",
  BASE_GREY_35: "#e4e4e4",
  BASE_GREY_50: "#cdcdd0",
  BASE_GREY_100: "#a8a8ad",
  BASE_GREY_200: "#8b8b92",
  BASE_GREY_300: "#72737a",
  BASE_GREY_400: "#595a63",
  BASE_BLACK_500: "#454550",
  BASE_BLACK_600: "#30313c",
  BASE_BLACK_700: "#2a2a2a",
  BASE_BLACK_800: "#070817",
  CONTEXT_PRIMARY_20: "#ecffce",
  CONTEXT_PRIMARY_50: "#7fcc00",
  CONTEXT_PRIMARY_100: "#65a300",
  CONTEXT_PRIMARY_200: "#4f7f00",
  CONTEXT_PRIMARY_800: "#3a591a",
  CONTEXT_SECONDARY_20: "#dfd5ff",
  CONTEXT_SECONDARY_50: "#8267d3",
  CONTEXT_SECONDARY_100: "#6045af",
  CONTEXT_SECONDARY_200: "#3f2787",
  CONTEXT_SECONDARY_800: "#1d1647",
  CONTEXT_SUCCESS_20: "#ebf7df",
  CONTEXT_SUCCESS_50: "#90c458",
  CONTEXT_SUCCESS_100: "#63992e",
  CONTEXT_SUCCESS_200: "#4b7322",
  CONTEXT_SUCCESS_800: "#3a591a",
  CONTEXT_WARNING_20: "#fff6d9",
  CONTEXT_WARNING_50: "#f8cc43",
  CONTEXT_WARNING_100: "#f3b700",
  CONTEXT_WARNING_200: "#d9a600",
  CONTEXT_WARNING_800: "#b38900",
  CONTEXT_DISABLED_20: "#f2f2f3",
  CONTEXT_DISABLED_50: "#cdcdd0",
  CONTEXT_DISABLED_100: "#a8a8ad",
  CONTEXT_DISABLED_200: "#8b8b92",
  CONTEXT_DISABLED_300: "#72737a",
  CONTEXT_DANGER_20: "#f8d4cd",
  CONTEXT_DANGER_50: "#e6735c",
  CONTEXT_DANGER_100: "#f85130",
  CONTEXT_DANGER_200: "#bf4830",
  CONTEXT_DANGER_800: "#993926",
  CONTEXT_INFO_20: "#d2e7ff",
  CONTEXT_INFO_50: "#509cf2",
  CONTEXT_INFO_100: "#2b7dd9",
  CONTEXT_INFO_200: "#2467b3",
  CONTEXT_INFO_800: "#1e5594"
};

export default COLORS;